<template>
  <v-card variant="text">
    <v-row>
      <v-col cols="12" sm="10">
        <v-card-title class="text-wrap" style="word-break: break-word">
          {{ pregunta.texto }}
        </v-card-title>
      </v-col>
      <v-col cols="auto" class="hidden-xs">
        <v-chip color="success" variant="outlined" class="mt-3">
          <v-tooltip activator="parent">{{ t('Clasifica_los_conceptos') }}</v-tooltip>
          <v-icon icon="mdi-tag-multiple" start></v-icon>
          {{ t('clasificar') }}
        </v-chip>
      </v-col>
    </v-row>
    <v-card-text>
      <v-row no-gutters>
        <v-col cols="6" v-for="group in groupedOptions" :key="group.nombre">
          <v-card :title="group.nombre">
            <draggable v-model="group.opciones" group="shared" :animation="300" :disabled="haRespondido">
              <template #item="{ element: item }">
                <v-list>
                  <v-list-item :base-color="getColor(item)">
                    <v-chip>{{ item.texto }}</v-chip>
                  </v-list-item>
                </v-list>
              </template>
            </draggable>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
  <v-btn block v-if="!haRespondido" :disabled="loading" color="primary" class="mt-3" @click="enviarCuestionario">
    {{ t('Comprueba') }}
  </v-btn>
  <v-btn block v-if="haRespondido" :disabled="loading" color="primary" class="mt-3" @click="next">
    {{ t('Continua') }}
  </v-btn>
</template>

<script setup>
import { ref, watch } from 'vue';
import draggable from 'vuedraggable';
import { useI18n } from 'vue-i18n';
import { axios } from '../axios';

const props = defineProps({
  pregunta: {
    type: Object,
    default: () => ({})
  }
});
const { t } = useI18n();
const emits = defineEmits(['respuesta-enviada']);

const loading = ref(false);
const haRespondido = ref(false);

const groupedOptions = ref([]);

// Función para calcular las opciones agrupadas
function calculateGroupedOptions(options) {
  const nombres = Array.from(new Set(options.map(opcion => opcion.texto2)));
  const groupSize = Math.ceil(options.length / nombres.length);
  const grupos = [];
  nombres.forEach((nombre, index) => {
    const start = index * groupSize;
    const end = start + groupSize;
    grupos.push({
      nombre: nombre,
      opciones: options.slice(start, end)
    });
  });
  groupedOptions.value = grupos;
}

// Watcher que observa cambios en props.pregunta.opciones
watch(() => props.pregunta.opciones, (newOptions) => {
  if (newOptions) {
    calculateGroupedOptions(newOptions);
  }
});

async function enviarCuestionario() {
  loading.value = true;
  haRespondido.value = true;

  const idsCorrectos = []; // Inicializa un array para almacenar los IDs de las respuestas correctas

  // Comprobar si todos los items están en el grupo correcto
  groupedOptions.value.forEach(group => {
    group.opciones.forEach(item => {
      if (item.texto2 === group.nombre) {
        item.correct = true; // Correcto
        idsCorrectos.push(item.id); // Añadir el ID a la lista si la opción es correcta
      } else {
        item.correct = false; // Incorrecto
      }
    });
  });

  const datosParaEnviar = {
    opcion_respuesta_ids: idsCorrectos
  };

  try {
    const respuesta = await axios.post(`enviar_respuestas/`, datosParaEnviar);
    if (respuesta.data.success) {
      haRespondido.value = true;
    } else {
      console.error('Error al enviar respuestas:', respuesta.data.message);
    }
    loading.value = false;
  } catch (error) {
    console.error('Error al realizar la solicitud:', error);
    loading.value = false;
  }

  loading.value = false;
}


function getColor(item) {
  if (!haRespondido.value) return 'primary'; // Default color before response
  return item.correct ? 'green' : 'red';
}

function next() {
  emits('respuesta-enviada', props.pregunta);
}

// Calcular inicialmente al montar el componente
calculateGroupedOptions(props.pregunta.opciones);
</script>